














































import { Vue, Component, Prop } from 'vue-property-decorator';
import { store, signout, bus, client, getUserInfo } from '../../shared';
import { UserInfo } from '../../shared/user';
import _ from 'lodash';
@Component({})
export default class BaseHeader extends Vue {
    activeSession: any = {};
    signout = signout;
    lblSessionTimeoutMessage: any = '';
    minutes: number = 0;
    seconds: number = 0;
    minute: number = 0;
    second: number = 0;
    form: any = {};
    get userSession() {
        return store.userSession;
    }
    get welcomeName() {
        return store.userSession != null ? store.userSession.userName : '';
    }

    get userInfo() {
        return store.userInfo;
    }
    onidle() {
        this.lblSessionTimeoutMessage = '';
        signout();
     }
    onRemind(time: any) {
        // this.lblSessionTimeoutMessage = '';
        //// alert seconds remaining to 00:00
        //// const minute === (time / 60) | 0;
        // this.second = time % 60 | 0;
        // this.minute = time / 60 | 0;

        // this.minutes = this.minute < 10 ? 0 + this.minute : this.minute;
        // this.seconds = this.second < 10 ? 0 + this.second : this.second;
        // this.lblSessionTimeoutMessage = 'Your session will expire and you will be logged out in ' + `${this.minutes}:${this.seconds}`;
        this.$swal({
            title: 'Session Timeout',
            text: 'Your session is about to expire due to inactivity',
            icon: 'warning',
            timer: 60000,
            showCancelButton: true,
            customClass: {
                confirmButton: 'btn btn-info m-1',
                cancelButton: 'btn btn-secondary m-1',
            },
            confirmButtonText: 'Keep me logged in!',
            cancelButtonText: 'Log me out.',
            html: false,
        }).then(async (result: any) => {
            if (result.value) {
               // button click restarts timer
            } else if (result.dismiss === 'cancel') {
                signout();
            }
        });
     }
    loadToForm() {
        bus.$on('userInfo', (payload: any) => {
            Object.assign(this.form, payload.data.form);
            Object.assign(this.form, payload.study.form);
            this.activeSession = JSON.parse(
                localStorage.getItem(this.userInfo.userInfo.userName) || '{}',
            );
            if (!_.isEmpty(this.activeSession)) {
                this.form.personId = this.activeSession.personId;
            }
        });
    }
    mounted() {
        this.loadToForm();
    }
}
